var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hideNavbar
    ? _c(
        "nav",
        {
          staticClass: "navbar is-fixed-top is-white",
          attrs: {
            role: "navigation",
            "aria-label": "main navigation",
            lang: _vm.language,
          },
        },
        [
          _c("div", { staticClass: "navbar-container" }, [
            _c(
              "div",
              { staticClass: "navbar-brand" },
              [
                _c(
                  "router-link",
                  { staticClass: "navbar-item", attrs: { to: _vm.urlHome } },
                  [
                    _c("img", {
                      staticClass: "navbar-icon",
                      attrs: { src: "/icon.png" },
                    }),
                    _vm.language === "it"
                      ? _c("img", {
                          staticClass: "navbar-logo",
                          attrs: { src: "/logo_ita.svg" },
                        })
                      : _vm.language === "es"
                      ? _c("img", {
                          staticClass: "navbar-logo",
                          attrs: { src: "/logo_esp.svg" },
                        })
                      : _c("img", {
                          staticClass: "navbar-logo",
                          attrs: { src: "/logo_eng.svg" },
                        }),
                  ]
                ),
                _c(
                  "a",
                  {
                    staticClass: "navbar-burger burger",
                    class: _vm.navbarClass,
                    attrs: {
                      role: "button",
                      "aria-label": "menu",
                      "aria-expanded": "false",
                    },
                    on: { click: _vm.toggleNavbar },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }),
                    _c("span", { attrs: { "aria-hidden": "true" } }),
                    _c("span", { attrs: { "aria-hidden": "true" } }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "navbar-menu",
                class: _vm.navbarClass,
                attrs: { id: "navbar" },
              },
              [
                _c(
                  "div",
                  { staticClass: "navbar-end" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "navbar-item",
                        attrs: { to: _vm.urlHome },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("menu.home")))])]
                    ),
                    !_vm.accessToken
                      ? _c(
                          "router-link",
                          {
                            staticClass: "navbar-item",
                            attrs: { to: _vm.urlLogin },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("menu.login")))])]
                        )
                      : _vm._e(),
                    _vm.tokenType === "company"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "navbar-item has-dropdown is-hoverable",
                          },
                          [
                            _c("a", { staticClass: "navbar-link" }, [
                              _vm._v(_vm._s(_vm.$t("menu.panel"))),
                            ]),
                            _c(
                              "div",
                              { staticClass: "navbar-dropdown" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navbar-item",
                                    attrs: {
                                      to:
                                        "/" +
                                        _vm.$route.params.language +
                                        "/panel/invite-codes",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("menu.codes"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navbar-item",
                                    attrs: {
                                      to:
                                        "/" +
                                        _vm.$route.params.language +
                                        "/panel/fitness-league",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("menu.ranking"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navbar-item",
                                    attrs: {
                                      to:
                                        "/" +
                                        _vm.$route.params.language +
                                        "/panel/analytics",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("menu.analytics"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navbar-item",
                                    attrs: {
                                      to:
                                        "/" +
                                        _vm.$route.params.language +
                                        "/panel/ticket",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("menu.tickets"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navbar-item",
                                    attrs: {
                                      to:
                                        "/" +
                                        _vm.$route.params.language +
                                        "/panel/password",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("menu.password"))),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.$route.name === "promo"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "navbar-item",
                            attrs: { to: _vm.urlPromoCode },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("menu.promo_code"))),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.accessToken &&
                    _vm.userState &&
                    _vm.userState.subscriptionPanelActive
                      ? _c(
                          "form",
                          {
                            staticClass: "navbar-item",
                            attrs: {
                              method: "POST",
                              target: "_blank",
                              action: "/api/user/customer-portal",
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "hidden", name: "token" },
                              domProps: { value: _vm.accessToken },
                            }),
                            _c(
                              "button",
                              {
                                staticClass: "span",
                                attrs: { type: "submit" },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("menu.subscription"))),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.accessToken &&
                    _vm.userState &&
                    _vm.userState.subscriptionPanelActive
                      ? _c(
                          "router-link",
                          {
                            staticClass: "navbar-item",
                            attrs: { to: _vm.urlProfile },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("menu.profile")))])]
                        )
                      : _vm.tokenType === "user"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "navbar-item",
                            attrs: { to: _vm.urlProfile },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("menu.subscription"))),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.accessToken && _vm.tokenType === "user"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "navbar-item",
                            attrs: { to: _vm.urlAccount },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("menu.authmanage"))),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.accessToken
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: { click: _vm.logout },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("menu.logout")))])]
                        )
                      : _vm.$route.name !== "promo"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "navbar-item",
                            attrs: { to: _vm.urlPromoCode },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("menu.promo_code"))),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      )
    : _c("div", { staticClass: "minimal-navbar" }, [
        _c("div", { staticClass: "columns is-centered is-mobile" }, [
          _c(
            "div",
            { staticClass: "column is-narrow" },
            [
              _c("router-link", { attrs: { to: _vm.urlHome } }, [
                _vm.language === "it"
                  ? _c("img", {
                      staticClass: "navbar-logo",
                      attrs: { src: "/logo_ita.svg" },
                    })
                  : _vm.language === "es"
                  ? _c("img", {
                      staticClass: "navbar-logo",
                      attrs: { src: "/logo_esp.svg" },
                    })
                  : _c("img", {
                      staticClass: "navbar-logo",
                      attrs: { src: "/logo_eng.svg" },
                    }),
              ]),
            ],
            1
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }